import {
  type CheckoutShippingChange,
  ClientCartAction,
  ClientCartActionCartRef,
  ClientCartFullBillingAddress,
  SwarovskiOptikClientCart,
} from "@swo/storefront";
import { Either } from "fp-ts/es6/Either";
import { performCartAction } from "../perform-cart-action";

import { SwarovskiOptikErrorClientResponse } from "../../types";

export const setBillingAddress = (
  token: string,
  localeCode: string,
  segmentKey: string,
  _cartRef: ClientCartActionCartRef,
  billingAddress: ClientCartFullBillingAddress,
  preselection: CheckoutShippingChange["method"] | undefined,
  baseUrl?: URL,
): Promise<Either<SwarovskiOptikErrorClientResponse, SwarovskiOptikClientCart>> => {
  const cartRef: ClientCartActionCartRef = {
    id: _cartRef.id,
    version: _cartRef.version,
  };

  const actionBody: ClientCartAction = {
    tag: "checkout-billing-address-change",
    cartRef: cartRef,
    billingAddress: billingAddress,
    preselection,
  };

  return performCartAction(token, localeCode, segmentKey, baseUrl)(actionBody);
};
